import { z } from 'zod';
import { functions } from '../../firebase';

export const inventoryItemSchema = z.object({
  id: z.string(),
  type: z.string(),
  name: z.string(),
  internalId: z.string(),
  identifier: z.string(),
  iccid: z.string(),
  phoneNumber: z.string(),
  orgId: z.string(),
  orgTitle: z.string(),
});
export type LinkedInventoryItem = z.infer<typeof inventoryItemSchema>;
const response = z.object({
  version: z.number(),
  inventoryId: z.string().nullable(),
  item: inventoryItemSchema.nullable(),
  sim: inventoryItemSchema.nullable(),
  choices: z.array(inventoryItemSchema),
  warnings: z.array(z.string()),
  canEdit: z.boolean(),
  deviceId: z.string(),
});
export async function getSensorInventory(orgId: string, sensorId: string) {
  const result = await functions.httpsCallable('settings')({
    requestType: 'GET_SENSOR_INVENTORY',
    payload: { orgId, sensorId },
  });
  return response.parse(result.data);
}
export async function saveSensorInventory(
  orgId: string,
  sensorId: string,
  inventoryId: string | null,
  expectedVersion: number
) {
  await functions.httpsCallable('settings')({
    requestType: 'SAVE_SENSOR_INVENTORY',
    payload: { orgId, sensorId, inventoryId, expectedVersion },
  });
}
export async function saveInventoryDevice(payload: object) {
  await functions.httpsCallable('settings')({
    requestType: 'SAVE_INVENTORY_DEVICE',
    payload: Object.fromEntries(Object.entries(payload).filter(([, value]) => value !== undefined)),
  });
}
